import React, { useState } from 'react';
import GeneratePrompt from '../../components/GeneratePrompt/GeneratePrompt';
import SplashCursor from '../../components/ReactBits/splash_cursor';
import './ProjectPrompt.css';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import { useNavigate } from 'react-router-dom';

const ProjectPrompt = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionError, setSubmissionError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (formData) => {
    setIsSubmitting(true);
    setSubmissionError('');
    
    try {
      const response = await fetch('https://api-uifytpudeq-uc.a.run.app', {
        method: 'POST',   
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      const data = await response.json();
      
      navigate('/submission-success', { 
        state: { 
          requirements: data.requirements,
          email: formData.email 
        } 
      });
      
    } catch (error) {
      console.error('Submission error:', error);
      setSubmissionError('Failed to submit project. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Navbar/>
      <SplashCursor />
      <div className="project-prompt-page">
        <GeneratePrompt 
          onSubmit={handleSubmit} 
          isSubmitting={isSubmitting}
          submissionError={submissionError}
        />
      </div>
      {/* <Footer/> */}
    </>
  );
};

export default ProjectPrompt;